<template>
  <div class="animated fadeIn" v-if="partner">

    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-user text-primary mr-2"></i>
          Ficha de socio
        </h4>
      </b-col>
    </b-row>

    <b-row>
      <b-card class="w-100 mb-2">
        <b-row>
          <b-col md="8">

            <b-row>
              <b-col md="4">
                Codigo: <span class="font-weight-bold">{{ partner.code }}</span>
              </b-col>
              <b-col md="8">
                Sede: <span class="font-weight-bold">{{ partner.headquarters.name }}</span>
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col md="4">
                NIF: <span class="font-weight-bold">{{ partner.nif }}</span>
              </b-col>
              <b-col md="4">
                Nombre: <span class="font-weight-bold">{{ partner.name }}</span>
              </b-col>
              <b-col md="4">
                Apellidos: <span class="font-weight-bold">{{ partner.surname }}</span>
              </b-col>
            </b-row>

          </b-col>

          <b-col md="3">

            <b-row class="mb-1">
              Estado:
              <button
                type="button"
                :disabled="isPartnerActive"
                v-bind:class="[isPartnerActive ? 'btn-primary' : 'btn-light', 'ml-2', 'btn', 'btn-brand', 'btn-primary', 'btn-sm', 'py-0', 'px-1']"
                @click="$refs.subscribeModal.show()">
                <small>Alta</small>
              </button>
              <button
                type="button"
                :disabled="!isPartnerActive"
                v-bind:class="[isPartnerActive ? 'btn-light' : 'btn-primary', 'ml-2', 'btn', 'btn-brand', 'btn-primary', 'btn-sm', 'py-0', 'px-1']"
                @click="$refs.unsubscribeModal.show()">
                <small>Baja</small>
              </button>
              <template v-if="!isPartnerActive && !!partner.deactivatedAt">
                <b-badge variant="warning" class="ml-2 d-flex align-items-center">
                  {{ new Date(partner.deactivatedAt) | dateFormat('DD/MM/YYYY') }}
                </b-badge>
                <b-badge variant="warning" class="ml-2 d-flex align-items-center">
                  {{getUnsubscribeReason(partner.unsubscribeReasonId)}}
                </b-badge>
              </template>

              <b-modal
                id="subscribeModal"
                ref="subscribeModal"
                hide-footer
                class="text-center"
                title="Dar de Alta a Socio"
                centered>
                <b-form @submit.prevent="activatePartner">
                  <b-row class="mx-3">


                    <b-form-group
                      label="<strong>Fecha de Alta *</strong>"
                      :horizontal="true"
                      class="w-100 mb-3">
                      <v-date-picker
                        v-model="subscribe.date"
                        class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                        :required="true">
                      </v-date-picker>
                    </b-form-group>
                  </b-row>
                  <!-- !-->
                  <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                    <button
                      type="submit"
                      class="btn btn-brand btn-primary col-auto btn-lg float-right"
                      sm="12"
                      :disabled="!subscribe.date">
                      Confirmar
                    </button>
                  </b-row>
                </b-form>
              </b-modal>

              <b-modal
                id="unsubscribeModal"
                ref="unsubscribeModal"
                hide-footer
                class="text-center"
                title="Dar de Baja a Socio"
                centered>
                <b-form @submit.prevent="deactivatePartner" v-if="activeUnsubscribeReasons.length">
                  <b-row class="mx-3">
                    <b-form-group
                      label="<strong>Motivo de Baja</strong>"
                      label-for="unsubscribe-reason"
                      :horizontal="true"
                      class="w-100 mt-3 mb-3">
                      <multiselect
                        name="unsubscribe-reason"
                        v-model="unsubscribe.reason"
                        :options="activeUnsubscribeReasons"
                        label="name"
                        track-by="uuid"
                        :multiple="false"
                        :allowEmpty="false"
                        placeholder="Seleccione"
                        selectLabel="+"
                        deselectLabel="-">
                      </multiselect>
                    </b-form-group>
                    <!--                                        <b-form-group-->
                    <!--                                            label-for="deferred-unsubscribe"-->
                    <!--                                            :horizontal="false"-->
                    <!--                                            class="w-100 mt-1 mb-3 text-left">-->
                    <!--                                            <b-form-checkbox-->
                    <!--                                                id="deferred-unsubscribe"-->
                    <!--                                                v-model="unsubscribe.deferred">-->
                    <!--                                                Baja en Diferido-->
                    <!--                                            </b-form-checkbox>-->
                    <!--                                        </b-form-group>-->
                    <b-form-group
                      label="<strong>Fecha de baja *</strong>"
                      :horizontal="true"
                      class="w-100 mb-3">
                      <v-date-picker
                        v-model="unsubscribe.date"
                        class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                        :required="true">
                      </v-date-picker>
                    </b-form-group>
                  </b-row>
                  <!-- !-->
                  <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                    <button
                      type="submit"
                      class="btn btn-brand btn-primary col-auto btn-lg float-right"
                      sm="12"
                      :disabled="!unsubscribe.reason">
                      Confirmar
                    </button>
                  </b-row>
                </b-form>
              </b-modal>
            </b-row>

            <b-row>
              Situación:
              <button
                type="button"
                :disabled="isPartnerLocated"
                v-bind:class="[isPartnerLocated ? 'btn-primary' : 'btn-light', 'ml-2', 'btn', 'btn-brand', 'btn-primary', 'btn-sm', 'py-0', 'px-1']"
                @click="setPartnerAsLocated">
                <small>Localizado</small>
              </button>
              <button
                type="button"
                :disabled="!isPartnerLocated"
                v-bind:class="[isPartnerLocated ? 'btn-light' : 'btn-primary', 'ml-2', 'btn', 'btn-brand', 'btn-primary', 'btn-sm', 'py-0', 'px-1']"
                @click="$refs.notLocatedModal.show()">
                <small>No Localizado</small>
              </button>

              <b-modal
                id="notLocatedModal"
                ref="notLocatedModal"
                hide-footer
                class="text-center"
                title="Marcar socio como No Localizado"
                centered>
                <b-form @submit.prevent="setPartnerAsNotLocated">
                  <b-row class="mx-3">
                    <b-form-group
                      label-for="send-email"
                      :horizontal="false"
                      class="w-100 mt-1 mb-3 text-left">
                      <b-form-checkbox
                        id="send-email"
                        v-model="notLocated.sendEmail">
                        Notificar por correo
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      :horizontal="false"
                      class="w-100 mb-1"
                      v-if="notLocated.sendEmail">
                      <b-form-textarea
                        v-model="notLocated.emailMessage"
                        placeholder="Mensaje"
                        :rows="3"
                        :max-rows="6">
                      </b-form-textarea>
                    </b-form-group>
                  </b-row>
                  <!-- !-->
                  <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                    <button
                      type="submit"
                      class="btn btn-brand btn-primary col-auto btn-lg float-right"
                      sm="12"
                      :disabled="!!notLocated.sendEmail && !notLocated.emailMessage">
                      Confirmar
                    </button>
                  </b-row>
                </b-form>
              </b-modal>
            </b-row>

          </b-col>

          <b-col md="1" class="p-0">

            <div class="float-right">
              <b-dropdown variant="link" no-caret>
                <template slot="button-content"><i class="cui-options h4"></i></template>

                <b-dropdown-item
                  href="#"
                  @click.prevent="showSendMemberCardModal">Enviar carnet de socio
                </b-dropdown-item>
                <b-dropdown-item
                  href="#"
                  @click.prevent="showSendMemberCertificateModal">Enviar certificado de pertenencia
                </b-dropdown-item>
                <b-dropdown-item
                  href="#"
                  @click.prevent="showSendFeeCertificateModal">Enviar certificado de cuota
                </b-dropdown-item>
              </b-dropdown>
            </div>

          </b-col>

        </b-row>

        <!-- MODALES DE OPCIONES -->

        <!-- Enviar carnet de socio -->
        <b-modal
          id="sendMemberCardModal"
          ref="sendMemberCardModal"
          title="Enviar Carnet de Socio"
          hide-footer
          centered>

          <b-row class="mt-2 mx-1">

            <b-card class="w-100">
              <span v-html="memberCardEmail"></span>
            </b-card>

          </b-row>

          <b-row class="border-top pt-3 px-3 flex-row-reverse">
            <button
              class="btn btn-brand btn-primary col-auto btn-lg float-right"
              @click="sendMemberCardEmail">
              Enviar
            </button>
          </b-row>

        </b-modal>

        <!-- Enviar certificado de pertenencia -->
        <b-modal
          id="sendMemberCertificateModal"
          ref="sendMemberCertificateModal"
          title="Enviar Certificado de Pertenencia"
          hide-footer
          centered>

          <b-row class="mt-2 mx-5">

            <b-form-group
              label="<strong>Tipo</strong>"
              label-cols="2"
              :horizontal="true"
              class="w-100 mx-4">

              <multiselect
                v-model="certificate.type"
                :allow-empty="false"
                :options="certificateTypes"
                :multiple="false"
                :custom-label="opt => opt === 'MEMBER' ? 'Socio' : 'Empresa'">
              </multiselect>

            </b-form-group>

            <b-form-group
              label="<strong>Año</strong>"
              label-cols="2"
              :horizontal="true"
              class="w-100 mx-4">

              <multiselect
                v-model="certificate.year"
                :allow-empty="false"
                :options="years"
                :multiple="false">
              </multiselect>

            </b-form-group>

            <b-form-group class="w-100 mx-4">

              <button
                class="btn btn-brand btn-link float-right"
                @click="openCertificatePreview">
                Previsualizar
              </button>

            </b-form-group>

          </b-row>

          <b-row class="border-top pt-3 px-3 flex-row-reverse align-content-between">
            <button
              class="btn btn-brand btn-primary btn-lg float-right"
              @click="sendMemberCertificateEmail">
              Enviar
            </button>
          </b-row>

        </b-modal>


        <!-- Enviar certificado de cuota -->
        <b-modal
          id="sendFeeCertificateModal"
          ref="sendFeeCertificateModal"
          title="Enviar Certificado de Cuota"
          hide-footer
          centered>

          <b-row class="mt-2 mx-5">
            <b-form-group
              label="<strong>Tipo</strong>"
              label-cols="3"
              :horizontal="true"
              class="w-100 mx-4">

              <multiselect
                v-model="certificate.type"
                :allow-empty="false"
                :options="certificateTypes"
                :multiple="false"
                :custom-label="opt => opt === 'MEMBER' ? 'Socio' : 'Empresa'">
              </multiselect>

            </b-form-group>

            <b-form-group
              label="<strong>Año</strong>"
              label-cols="3"
              :horizontal="true"
              class="w-100 mx-4">

              <multiselect
                v-model="certificate.year"
                :allow-empty="false"
                :options="years"
                :multiple="false">
              </multiselect>

            </b-form-group>

            <b-form-group
              label-for="certificate-amount-check"
              :horizontal="false"
              class="w-100 mt-1 mb-3 text-left">
              <b-form-checkbox
                id="certificate-amount-check"
                v-model="certificate.aomuntCheck">
                Introducir cuota manual
              </b-form-checkbox>
            </b-form-group>
            <b-form-group
              label="<strong>Cantidad</strong>"
              label-cols="3"
              :horizontal="true"
              v-if="certificate.aomuntCheck"
              class="w-100 mx-4">
              <b-form-input
                v-model="certificate.amount"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label-for="certificate-signature-date-check"
              :horizontal="false"
              class="w-100 mt-1 mb-3 text-left">
              <b-form-checkbox
                id="certificate-signature-date-check"
                v-model="certificate.signatureDateCheck">
                Introducir fecha de firma manual
              </b-form-checkbox>
            </b-form-group>
            <b-form-group
              label="<strong>Fecha</strong>"
              label-cols="3"
              :horizontal="true"
              v-if="certificate.signatureDateCheck"
              class="w-100 mx-4">
              <v-date-picker
                v-model='certificate.signatureDate'
                class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                popoverDirection="top">
              </v-date-picker>
            </b-form-group>

            <b-form-group class="w-100 mx-4">

              <button
                class="btn btn-brand btn-link float-right"
                @click="openFeeCertificatePreview">
                Previsualizar
              </button>

            </b-form-group>

          </b-row>

          <b-row class="border-top pt-3 px-3 flex-row-reverse align-content-between">
            <button
              class="btn btn-brand btn-primary btn-lg float-right"
              @click="sendFeeCertificateEmail">
              Enviar
            </button>
          </b-row>

        </b-modal>

      </b-card>
    </b-row>

    <b-row class="mt-3">
      <b-col md="8" class="p-0">
        <b-tabs v-model="tab" lazy card>
          <b-tab title="Información Básica">
            <tab1
              :partner="partner"
              :headquarters="headquarters"
              @sendPartner="setPartner($event)"></tab1>
          </b-tab>

          <b-tab title="Datos Personales">
            <tab2
              :partner="partner"
              :campaign-types="campaignTypes"
              @sendPartner="setPartner($event)"></tab2>
          </b-tab>

          <b-tab title="Datos Bancarios">
            <tab3
              :partner="partner"
              :headquarters="headquarters"
              :feeTypes="feeTypes"
              @sendPartner="setPartner($event)"></tab3>
          </b-tab>

          <b-tab title="Información Adicional">
            <tab4
              :partner="partner"
              :associatedProjects="associatedProjects"
              :simplifiedUsers="simplifiedUsers"
              @sendPartner="setPartner($event)"
              @getActivity="getActivity"></tab4>
          </b-tab>

          <b-tab title="Histórico">
            <tab5 :activity="activity"></tab5>
          </b-tab>
        </b-tabs>
      </b-col>

      <b-col md="4" class="p-0 pl-2 mt-2">

        <b-tabs lazy card>
          <div v-for="(noteType) in noteTypes" :key="noteType.uuid">
            <b-tab @click="changeTabNote(noteType);checkDelete(noteType.name);checkUpdate(noteType.name)">
              <template #title>{{noteType.name}}</template>

              <div class="note-buttons p-0 pr-1 float-right">
                <button
                  v-if="createNotes"
                  v-show="!showNewNote"
                  class="btn btn-brand btn-link p-0"
                  @click="showNewNote = true">Nueva Nota
                </button>
                <span v-show="showNewNote">
                  <button class="btn btn-brand btn-link p-0"
                  @click="showNewNote = false">Cancelar</button>
                  &nbsp;
                  <button class="btn btn-brand btn-link p-0" @click="saveNewNote">Guardar</button>
                </span>

              </div>

              <h5 class="w-100 text-primary pl-1 mb-3">
                <span>Notas</span>
              </h5>

              <b-card class="notes-container">
                <div class="note-card sticky-top" v-show="showNewNote">

                  <b-form-textarea
                    id="note"
                    v-model="newNote"
                    placeholder="Agregue su nota"
                    :rows="3"
                    :max-rows="6">
                  </b-form-textarea>

                </div>

                <div v-if="notes.filter(n => noteTypeId === n.noteTypeId)">
                  <template v-if="mixinCheckPermission('ALL')">
                    <template v-for="(note, index) in notes.filter(n => noteTypeId === n.noteTypeId)">
                      <div class="note-card animated fadeIn" v-if="!note.deleted"  :key="note.uuid">
                        <div class="font-weight-light">
                          <div v-if="!note.isEdit" class="float-right">{{ note.date | dateFormat('DD/MM/YYYY HH:mm') }}</div>
                          <div v-if="!note.isEdit">{{ note.user }}</div>
                        </div>
                        <hr class="mt-1">
                        <div v-if="!note.isEdit">{{ note.note }}</div>
                        <b-form-textarea
                          id="note"
                          v-if="note.isEdit"
                          v-model="note.note"
                          placeholder="Agregue su nota"
                          :rows="3"
                          :max-rows="6">
                        </b-form-textarea>

                        <hr class="mt-1">
                        <template v-if="!note.isEdit">
                          <b-row>
                            <b-col>
                              <b-button v-if="deleteNotes" variant="primary" size="sm" @click="deleteNote(note.uuid)">Eliminar nota</b-button>
                            </b-col>
                            <b-col>
                              <b-button class="float-right" variant="primary" size="sm" @click="editRowHandler(note, index)">Editar nota</b-button>
                            </b-col>
                          </b-row>
                        </template>
                          <template v-if="note.isEdit">
                            <button class="btn btn-brand btn-link p-0" @click="note.isEdit = false">Cancelar</button>
                            &nbsp;
                            <button class="btn btn-brand btn-link p-0" @click="updateNote(note, index)">Guardar</button>
                          </template>
                      </div>
                    </template>
                  </template>

                  <template v-else>
                    <template v-for="(note, index) in notes.filter(n => noteTypeId === n.noteTypeId)">
                      <div class="note-card animated fadeIn" v-if="!note.deleted"  :key="note.uuid">
                        <div class="font-weight-light">
                          <div v-if="!note.isEdit" class="float-right">{{ note.date | dateFormat('DD/MM/YYYY HH:mm') }}</div>
                          <div v-if="!note.isEdit">{{ note.user }}</div>
                        </div>
                        <hr class="mt-1">
                        <div v-if="!note.isEdit">{{ note.note }}</div>
                        <b-form-textarea
                          id="note"
                          v-if="note.isEdit"
                          v-model="note.note"
                          placeholder="Agregue su nota"
                          :rows="3"
                          :max-rows="6">
                        </b-form-textarea>

                        <hr class="mt-1">
                        <template v-if="!note.isEdit && note.userId === userUuid">
                          <b-row>
                            <b-col>
                              <b-button v-if="deleteNotes" variant="primary" size="sm" @click="deleteNote(note.uuid)">Eliminar nota</b-button>
                            </b-col>
                            <b-col>
                              <b-button class="float-right" variant="primary" size="sm" @click="editRowHandler(note, index)">Editar nota</b-button>
                            </b-col>
                          </b-row>
                        </template>
                        <template v-if="note.isEdit">
                          <button class="btn btn-brand btn-link p-0" @click="note.isEdit = false">Cancelar</button>
                          &nbsp;
                          <button class="btn btn-brand btn-link p-0" @click="updateNote(note, index)">Guardar</button>
                        </template>
                      </div>
                    </template>
                  </template>
                </div>
              </b-card>

            </b-tab>
          </div>
        </b-tabs>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col class="p-0">
        <b-card>

          <b-row class="mt-1 mb-1">
            <b-col>
              <h6 class="text-center">{{partner.linkMembersCount}} Socios Vinculados</h6>
            </b-col>
            <b-col>
              <h6 class="text-center">{{partner.cnaesCount}} CNAEs</h6>
            </b-col>
            <b-col>
              <h6 class="text-center">{{partner.certificatesCount}} Certificados de Pertenencia</h6>
            </b-col>
            <b-col>
              <h6 class="text-center">{{partner.feeCertificatesCount}} Certificados de Cuota</h6>
            </b-col>
          </b-row>

          <member-statistics-resume :member-id="partner.uuid" :show-legend="true"/>

        </b-card>
      </b-col>
    </b-row>


  </div>
</template>

<script>

  import {request, parseRequest} from '@/helpers/services';
  import {setupCalendar, DatePicker} from 'v-calendar';
  import Multiselect from 'vue-multiselect';
  import MemberStatisticsResume from '@/components/statistics/MemberStatisticsResume';
  import ClientNotesService from '@/services/client/client-notes-service';
  import VueNotifications from 'vue-notifications';
  import {getClientActivity} from "@/api/client-api";
  import {
    activateMember,
    deactivateMember,
    setMemberAsLocated,
    setMemberAsNotLocated,
    getMemberCardEmail,
    sendMemberCardEmail,
    getMemberCertificatePreview,
    getFeeCertificatePreview,
    sendMemberCertificateEmail,
    sendFeeCertificateEmail
  } from "@/api/member-api";
  import {getAssociatedProjects} from '@/api/associated-project-api';

  import {getUnsubscribeReasons} from "@/api/unsubscribe-reason-api";
  import tab1 from './Tab1';
  import tab2 from './Tab2';
  import tab3 from './Tab3';
  import tab4 from './Tab4';
  import tab5 from './Tab5';
  import moment from 'moment';
  import {getCampaignTypes} from "@/api/campaign-type-api";

  const clientNotesService = new ClientNotesService();

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      let temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  };

  export default {
    name: 'addPartners',
    components: {
      'v-date-picker': DatePicker,
      Multiselect,
      MemberStatisticsResume,
      tab1,
      tab2,
      tab3,
      tab4,
      tab5,
    },
    data: function () {
      return {
        topmenu: [
          {name: 'Volver', path: '/partners/accounts/list', brand: 'fa fa-arrow-left'},
        ],
        memberUuid: null,
        partner: null,
        headquarters: [],
        associatedProjects: [],
        feeTypes: [],
        campaignTypes: [],
        simplifiedUsers: [],
        activity: [],
        tab: null,
        notes: [],
        newNote: null,
        noteTypeId: null,
        showNewNote: false,
        createNotes: false,
        deleteNotes: false,
        editNotes: false,
        unsubscribeReasons: [],
        // TODO: change static data for data form request
        noteTypes: [],
        subscribe: {
          date: new Date()
        },
        unsubscribe: {
          reason: null,
          deferred: false,
          date: new Date()
        },
        notLocated: {
          sendEmail: false,
          emailMessage: null
        },
        finishedRequests: {
          headquarters: false,
          associatedProjects: false,
          feeTypes: false,
          activity: false,
          simplifiedUsers: false,
        },
        memberCardEmail: null,
        certificate: {
          type: 'MEMBER',
          year: new Date().getFullYear(),
          amountCheck: false,
          signatureDateCheck: false,
          amount: 0,
          signatureDate: new Date()
        },
        userUuid: null
      }
    },
    computed: {
      tabsDependenciesSatisfied() {
        return (
          this.finishedRequests.headquarters
          && this.finishedRequests.associatedProjects
          && this.finishedRequests.feeTypes
          && this.finishedRequests.activity
          && this.finishedRequests.simplifiedUsers
        );
      },
      isPartnerActive() {
        return (!!this.partner && !!this.partner.active && !this.partner.deactivatedAt)
      },
      activeUnsubscribeReasons() {
        return (this.unsubscribeReasons.filter((reason) => (!!reason.active)));
      },
      isPartnerLocated() {
        return (!!this.partner && !!this.partner.located)
      },
      years() {
        const year = new Date().getFullYear();
        return Array.from({length: year - 2000}, (value, index) => 2001 + index);
      },
      certificateTypes() {
        if (this.partner.companyNif) {
          return ['MEMBER', 'COMPANY'];
        } else {
          return ['MEMBER'];
        }
      }
    },
    mounted() {
      this.userUuid = this.authUser().uuid;
      this.memberUuid = this.$route.params.uuid;
      this.$eventHub.$emit('captureMenu', this.topmenu);
      if (this.$route.query.hasOwnProperty('tab') && this.$route.query.tab !== null) {
        this.tab = parseInt(this.$route.query.tab);
      } else {
        this.tab = 0;
      }
      request('members/' + this.memberUuid, 'get', 200)
        .then(u => {
          this.partner = u;
          this.getSimplifiedUsers();
        });
      this.getHeadquarters();
      this.getAssociatedProjects();
      this.getFeeTypes();
      this.getNotes();
      this.getNoteType();
      this.getActivity();
      this.getUnsubscribeReasons();
      this.getCampaignTypes();
    },

    methods: {
      setPartner(partner) {
        this.partner = Object.assign({}, partner);
        this.getActivity();
      },
      async getHeadquarters() {
        this.$_loadingMixin_showLoading();
        this.headquarters = await request('headquarters', 'get', 200);
        this.finishedRequests.headquarters = true;
        this.$_loadingMixin_hideLoading();
      },
      async getAssociatedProjects() {
        this.$_loadingMixin_showLoading();
        await getAssociatedProjects().then((associatedProjects) => this.associatedProjects = associatedProjects);
        this.finishedRequests.associatedProjects = true;
        this.$_loadingMixin_hideLoading();
      },
      async getFeeTypes() {
        this.$_loadingMixin_showLoading();
        this.feeTypes = await request('fee/types', 'get', 200);
        this.finishedRequests.feeTypes = true;
        this.$_loadingMixin_hideLoading();
      },
      async getSimplifiedUsers() {
        this.$_loadingMixin_showLoading();
        this.simplifiedUsers = await request('users-simplified?headquartersId=' + this.partner.headquarters.uuid, 'get', 200);
        this.finishedRequests.simplifiedUsers = true;
        this.$_loadingMixin_hideLoading();
      },
      async getActivity() {
        this.$_loadingMixin_showLoading();
        await getClientActivity(this.memberUuid)
          .then((activity) => {
            this.activity = activity;
            this.finishedRequests.activity = true;
          });
        this.$_loadingMixin_hideLoading();
      },
      async getUnsubscribeReasons() {
        this.$_loadingMixin_showLoading();
        await getUnsubscribeReasons()
          .then((unsubscribeReasons) => {
            this.unsubscribeReasons = unsubscribeReasons;
          });
        this.$_loadingMixin_hideLoading();
      },
      async getNotes() {
        clientNotesService.getNotes(this.memberUuid)
          .then((notes) => {
            this.notes = notes;
          })
          .catch((error) => {
            console.log("No se han podido recuperar las notas del socio" + error);
          });
      },
      async getCampaignTypes() {
        this.$_loadingMixin_showLoading();
        try {
          const campaignTypesResponse = await getCampaignTypes();
          this.campaignTypes = campaignTypesResponse.campaignTypes.map(campaignType => ({
            uuid: campaignType.uuid,
            name: campaignType.name
          }));
        } catch (error) {
          console.error('Error fetching campaign types:', error);
        } finally {
          this.$_loadingMixin_hideLoading();
        }
      },
      async getNoteType() {
        clientNotesService.getNoteType()
          .then((notesType) => {
            if (this.mixinCheckPermission('CLIENT_CARD')) {
              this.noteTypes = notesType;
            } else {
              let noteTypesData = [];
              notesType.forEach(note => {
                if ( note.name === 'Web' && this.mixinCheckPermission('READ_MEMBER_NOTES_WEB') ) {
                  noteTypesData.push(note);
                } else if (note.name === 'Fidelización' && this.mixinCheckPermission('READ_MEMBER_NOTES_LOYALTY')) {
                  noteTypesData.push(note);
                } else if (note.name === 'Contabilidad' && this.mixinCheckPermission('READ_MEMBER_NOTES_ACCOUNTING')) {
                  noteTypesData.push(note);
                }
              });
              this.noteTypes = noteTypesData;
            }
          })
          .catch((error) => {
            console.log("No se han podido recuperar los tipos de notas" + error);
          });
      },
      async activatePartner() {
        this.$_loadingMixin_showLoading();
        await activateMember(this.memberUuid, moment(this.subscribe.date).format('YYYY-MM-DD'))
          .then((member) => {
            this.setPartner(member);
            this.$refs.subscribeModal.hide();
            this.$_notificationMixin_success('Operación completada', 'El socio ha sido dado de alta');
          })
          .catch(() => {
            this.$_notificationMixin_error('Operación no completada', 'No se ha podido dar de alta al socio');
          });
        this.$_loadingMixin_hideLoading();
      },
      async deactivatePartner() {
        this.$_loadingMixin_showLoading();
        await deactivateMember(
          this.memberUuid,
          this.unsubscribe.reason.uuid,
          moment(this.unsubscribe.date).format('YYYY-MM-DD')
        )
          .then((member) => {
            this.setPartner(member);
            this.$refs.unsubscribeModal.hide();
            this.$_notificationMixin_success('Operación completada', 'El socio ha sido dado de baja');
          })
          .catch(() => {
            this.$_notificationMixin_error('Operación no completada', 'No se ha podido dar de baja al socio');
          });
        this.$_loadingMixin_hideLoading();
      },
      async setPartnerAsLocated() {
        this.$_loadingMixin_showLoading();
        await setMemberAsLocated(this.memberUuid)
          .then((member) => {
            this.setPartner(member);
            this.$_notificationMixin_success('Operación completada', 'El socio ha sido marcado como localizado');
          })
          .catch(() => {
            this.$_notificationMixin_error('Operación no completada', 'No se ha podido marcar el socio como localizado');
          });
        this.$_loadingMixin_hideLoading();
      },
      async setPartnerAsNotLocated() {
        this.$_loadingMixin_showLoading();
        await setMemberAsNotLocated(this.memberUuid, this.notLocated.sendEmail, this.notLocated.emailMessage)
          .then((member) => {
            this.setPartner(member);
            this.$refs.notLocatedModal.hide();
            this.$_notificationMixin_success('Operación completada', 'El socio ha sido marcado como no localizado');
          })
          .catch(() => {
            this.$_notificationMixin_error('Operación no completada', 'No se ha podido marcar el socio como no localizado');
          });
        this.$_loadingMixin_hideLoading();
      },
      getBadge(status) {
        return status === 'Active' ? 'success'
          : status === 'Inactive' ? 'secondary'
            : status === 'Pending' ? 'warning'
              : status === 'Banned' ? 'danger' : 'primary'
      },
      getRowCount(items) {
        return items.length;
      },
      deleteNote(uuid) {
        this.$_loadingMixin_showLoading();
        clientNotesService.deleteNote(this.memberUuid, uuid, this.noteTypeId)
          .then(() => {
            this.getNotes();
            this.showNewNote = false;
            document.getElementsByClassName("notes-container")[0].scrollTo(0, 0);
            this.$_loadingMixin_hideLoading();
          })
          .catch((error) => {
            this.$_loadingMixin_hideLoading();
            VueNotifications.error({
              title: 'Nota no eliminada',
              message: 'Se ha producido algún error y no hemos podido elmininar la nota'
            });
          })
      },
      changeTabNote(noteType) {
        this.noteTypeId = noteType.uuid
        this.newNote = null;
        this.createNotes = false;
        this.notes = this.notes.map(item => ({...item, isEdit: false}));

        if (
          this.mixinCheckPermission('ALL')
          ||
          this.mixinCheckPermission('CREATE_MEMBER_NOTES')
        ) {
          this.createNotes = true;
        } else {
          if (noteType.name === 'Web' && this.mixinCheckPermission('NEW_MEMBER_NOTES_WEB')) {
            this.createNotes = true;
          } else if (noteType.name === 'Fidelización' && this.mixinCheckPermission('NEW_MEMBER_NOTES_LOYALTY')) {
            this.createNotes = true;
          } else if (noteType.name === 'Contabilidad' && this.mixinCheckPermission('NEW_MEMBER_NOTES_ACCOUNTING')) {
            this.createNotes = true;
          }
        }
      },
      checkDelete(noteTypeName) {
        this.deleteNotes = false;
        if (
          this.mixinCheckPermission('ALL')
          ||
          this.mixinCheckIndividualPermission('DELETE_MEMBER_NOTES')
        ) {
          this.deleteNotes = true;
        } else if (noteTypeName === "Web" && this.mixinCheckIndividualPermission('DELETE_MEMBER_NOTES_WEB')) {
          this.deleteNotes = true;
        } else if (noteTypeName === 'Fidelización' && this.mixinCheckIndividualPermission('DELETE_MEMBER_NOTES_LOYALTY')) {
          this.deleteNotes = true;
        } else if (noteTypeName === 'Contabilidad' && this.mixinCheckIndividualPermission('DELETE_MEMBER_NOTES_ACCOUNTING')) {
          this.deleteNotes = true;
        } else {
          this.deleteNotes = false;
        }
      },
      checkUpdate(noteTypeName) {
        this.editNotes = false;
        if (
          this.mixinCheckPermission('ALL')
          ||
          this.mixinCheckIndividualPermission('EDIT_MEMBER_NOTES')
        ) {
          this.editNotes = true;
        } else if (noteTypeName === "Web" && this.mixinCheckIndividualPermission('EDIT_MEMBER_NOTES_WEB')) {
          this.editNotes = true;
        } else if (noteTypeName === 'Fidelización' && this.mixinCheckIndividualPermission('EDIT_MEMBER_NOTES_LOYALTY')) {
          this.editNotes = true;
        } else if (noteTypeName === 'Contabilidad' && this.mixinCheckIndividualPermission('EDIT_MEMBER_NOTES_ACCOUNTING')) {
          this.editNotes = true;
        } else {
          this.editNotes = false;
        }
      },
      saveNewNote() {
        this.$_loadingMixin_showLoading();
        clientNotesService.newNote(this.memberUuid, {note: this.newNote, noteTypeId: this.noteTypeId})
          .then(() => {
            this.getNotes();
            this.showNewNote = false;
            this.newNote = null;
            //this.noteTypeId = null;
            document.getElementsByClassName("notes-container")[0].scrollTo(0, 0);
            this.$_loadingMixin_hideLoading();
          })
          .catch((error) => {
            this.$_loadingMixin_hideLoading();
            VueNotifications.error({
              title: 'Nota no guardada',
              message: 'Se ha producido algún error y no hemos podido almacenar la nota'
            });
          })
      },
      editRowHandler(data, index) {
        this.notes.filter((someobject) => someobject.uuid === data.uuid).forEach(someobject => someobject.isEdit = true);
      },
      updateNote(data, index) {
        this.$_loadingMixin_showLoading();
        clientNotesService.updateNote(this.memberUuid, data.uuid, {note: data.note, noteTypeId: data.noteTypeId})
          .then(() => {
            this.getNotes();
            this.showNewNote = false;
            this.newNote = null;
            //this.noteTypeId = null;
            document.getElementsByClassName("notes-container")[0].scrollTo(0, 0);
            this.$_loadingMixin_hideLoading();
          })
          .catch((error) => {
            this.$_loadingMixin_hideLoading();
            VueNotifications.error({
              title: 'Nota no guardada',
              message: 'Se ha producido algún error y no hemos podido almacenar la nota'
            });
          })
        this.notes[index].isEdit = !this.notes[index].isEdit;
      },
      getTomorrowDate() {
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow;
      },

      async showSendMemberCardModal() {
        this.$_loadingMixin_showLoading();
        await getMemberCardEmail(this.memberUuid)
          .then((email) => {
            this.memberCardEmail = email;
            this.$refs.sendMemberCardModal.show();
          })
          .catch(() => {
            this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar la plantilla del email para enviar")
          });
        this.$_loadingMixin_hideLoading();
      },

      async sendMemberCardEmail() {
        this.$refs.sendMemberCardModal.hide();
        this.$_loadingMixin_showLoading();
        await sendMemberCardEmail(this.memberUuid)
          .then(() => {
            this.$_notificationMixin_success("Operación completada", "Email con carnet de socio enviado correctamente");
          })
          .catch(() => {
            this.$_notificationMixin_error("Se ha producido un error", "No hemos podido el email con el carnet de socio");
          });
        this.$_loadingMixin_hideLoading();
      },

      async showSendMemberCertificateModal() {
        this.$refs.sendMemberCertificateModal.show();
      },

      async showSendFeeCertificateModal() {
        this.$refs.sendFeeCertificateModal.show();
      },

      async openCertificatePreview() {
        this.$_loadingMixin_showLoading();
        await getMemberCertificatePreview(this.memberUuid, this.certificate.type, this.certificate.year)
          .then((blob) => {
            window.open(URL.createObjectURL(blob));
          })
          .catch(() => {
            this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar la previsualización del certificado");
          });
        this.$_loadingMixin_hideLoading();
      },

      async sendMemberCertificateEmail() {
        this.$refs.sendMemberCertificateModal.hide();
        this.$_loadingMixin_showLoading();
        await sendMemberCertificateEmail(this.memberUuid, this.certificate.type, this.certificate.year)
          .then(() => {
            this.$_notificationMixin_success("Operación completada", "Email con certificado de pertenencia enviado correctamente");
          })
          .catch(() => {
            this.$_notificationMixin_error("Se ha producido un error", "No hemos podido el certificado de pertenencia");
          });
        this.$_loadingMixin_hideLoading();
      },

      async openFeeCertificatePreview() {
        this.$_loadingMixin_showLoading();
        await getFeeCertificatePreview(this.memberUuid, this.certificate.type, this.certificate.year, this.certificate.amount, moment(this.certificate.signatureDate).format('YYYY-MM-DD'))
          .then((blob) => {
            window.open(URL.createObjectURL(blob));
          })
          .catch(() => {
            this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar la previsualización del certificado");
          });
        this.$_loadingMixin_hideLoading();
      },

      async sendFeeCertificateEmail() {
        this.$refs.sendFeeCertificateModal.hide();
        this.$_loadingMixin_showLoading();
        await sendFeeCertificateEmail(this.memberUuid, this.certificate.type, this.certificate.year, this.certificate.amount, moment(this.certificate.signatureDate).format('YYYY-MM-DD'))
          .then(() => {
            this.$_notificationMixin_success("Operación completada", "Email con certificado de cuota correctamente");
          })
          .catch(() => {
            this.$_notificationMixin_error("Se ha producido un error", "No hemos podido el email con el certificado de cuota");
          });
        this.$_loadingMixin_hideLoading();
      },
      getUnsubscribeReason(unsubscribeReasonId) {
        const unsubscribeReasonData = this.unsubscribeReasons.filter(unsubscribeReason => unsubscribeReason.uuid === unsubscribeReasonId);
        if (typeof unsubscribeReasonData[0] == 'object') {
          if (unsubscribeReasonData[0].hasOwnProperty('name')) {
            return unsubscribeReasonData[0].name;
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    color: inherit;
    background-color: transparent;
    border-bottom: 1px solid #c8ced3;
  }

  .notes-container {
    height: 500px;
    overflow-y: scroll;

    .card-body {
      padding: 0.5em;
    }
  }

  .note-card {
    background-color: #ECF0F3;
    padding: 10px;
    margin-bottom: 5px;
    border-radius: 5px;
    z-index: 99;
  }

  .btn-link:hover {
    text-decoration: none;
  }
</style>
